import { Stop } from "@api/graphql/generated/generated-types";

export function formatStopAddress(stop: Stop): string {
  return `${stop.streetAddress}, ${stop.city}, ${stop.state} ${stop.zipCode}`;
}
